<template>
    <div class="column_center_center"
        style="width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.7); position: fixed; top: 0; left: 0; right: 0; bottom: 0;">
        <div class="column_center_start address_input_container">
            <div class="column_center_start" style="width: 100%;">
                <text class="title" style="color: #FD5001; font-size: 20px; margin-bottom: 20px;">{{ isEdit ? "編輯地址" :
                    "新增地址"
                    }}</text>
                <!-- <select id="address-type-select" v-model="selectType">
                    <option value="" disabled selected hidden>地址類型</option>
                    <option v-for="(type, index) in types" :value="type.id" :key="index">
                        {{ type.name }}
                    </option>
                </select> -->
                <div class="h-11 w-[86%] mb-2.5 border border-[#AAAAAA] rounded-md">
                    <el-select v-model="selectedCity" placeholder="選擇縣市" size="medium">
                        <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id" />
                    </el-select>
                </div>

                <!-- <select class="mb-2.5" id="county-select" v-model="selectedCity"
                    :style="{ color: selectedCity === '選擇縣市' ? 'rgba(0, 0, 0, 0.3)' : 'black' }">
                    <option value="選擇縣市" disabled selected hidden>選擇縣市</option>
                    <option v-for="(city, index) in cities" :value="city.id" :key="index">
                        {{ city.name }}
                    </option>
                </select> -->

                <div class="h-11 w-[86%] border border-[#AAAAAA] rounded-md">
                    <el-select v-model="selectedCityArea" placeholder="選擇區域" no-data-text="請先選擇縣市" size="medium" style="color: #000;">
                        <el-option v-for="area in matchedCityAreas" :key="area.id" :label="area.name"
                            :value="area.id" />
                    </el-select>
                </div>

                <!-- <select id="area-select" v-model="selectedCityArea"
                    :style="{ color: selectedCity === '選擇縣市' ? 'rgba(0, 0, 0, 0.3)' : 'black' }">
                    <option value="選擇區域" disabled selected hidden>選擇區域</option>
                    <option v-for="(area, index) in matchedCityAreas" :value="area.id" :key="index">
                        {{ area.name }}
                    </option>
                </select> -->
                <el-input v-model="modifiedAddressData.address" :rows="4" type="textarea"
                    placeholder="請輸入收件人地址" :autosize="false" />

                <input type="text" name="name" placeholder="請輸入收件人姓名" v-model="modifiedAddressData.name">
                <input type="tel" maxlength="10" inputmode="tel" name="phone" placeholder="請輸入收件人電話"
                    v-model="modifiedAddressData.phone">
                <input type="text" name="comment" placeholder="請輸入備註" v-model="modifiedAddressData.comment">
            </div>
            <div class="row_center_between" style="width: 100%; margin-top: 30px;">
                <button @click="close" class="cancel_button">取消</button>
                <button @click="confirm" class="confirm_button">確認</button>
            </div>
        </div>
    </div>
</template>
<script>
import areaData from "@/area_data"
import commonUtilities from "@/utils/common.utils";
import { mapState } from 'vuex'
export default {
    data() {
        return {
            selectedCity: "選擇縣市",
            selectedCityArea: "選擇區域",
            selectType: "",
            modifiedAddressData: {
                "address": null,		 //詳細地址
                "city_id": null,			//城市編號
                "cityarea_id": null,		 //行政區編號
                "comment": null,			 //備註
                "is_default": 0,			 //是否為預設地址
                "name": null,		 //收件姓名
                "phone": null,		 //收件電話
                "postcode": null,		 //郵遞區號
                "type": null				//地址類型, 1: 通訊地址 2:收件地址 3: 發票地址
            },
            types: [
                {
                    name: "通訊地址",
                    id: 1
                },
                {
                    name: "收件地址",
                    id: 2
                },
                {
                    name: "發票地址",
                    id: 3
                }
            ],
            isEdit: false
        }
    },
    async mounted() {
        if (!this.cities.length) await this.$store.dispatch('basic/fetchCities')
        if (!this.cityAreas.length) await this.$store.dispatch('basic/fetchCityAreas')
        if (this.getSelectedAddressData) {
            this.isEdit = true
            const selectedAddressData = this.getSelectedAddressData
            this.modifiedAddressData = { ...selectedAddressData.data }
            this.selectedCity = this.modifiedAddressData.city_id
            this.selectedCityArea = this.modifiedAddressData.cityarea_id
            const type = this.types.find((type) => {
                return type.id == this.modifiedAddressData.type
            })
            this.selectType = type.id
            console.log("尚未編輯地址", this.modifiedAddressData)
        }
    },
    computed: {
        ...mapState('basic', {
            getSelectedAddressData: 'selectedAddressData',
            cities: 'cities',
            cityAreas: 'cityAreas',
        }),
        matchedCityAreas() {
            if (this.selectedCity == "選擇縣市") {
                return []
            }
            return this.cityAreas.filter(item => item.city_id == this.selectedCity)
        }
    },
    watch: {
        selectedCity() {
            this.modifiedAddressData.city_id = this.selectedCity
            console.log('selectedCity', this.selectedCity)
        },
        selectedCityArea() {
            this.modifiedAddressData.cityarea_id = this.selectedCityArea
            console.log('selectedCityArea', this.selectedCityArea)
            const postcode = areaData[this.selectedCityArea]
            this.modifiedAddressData.postcode = postcode
            console.log('郵遞區號', postcode)
        },
        selectType() {
            this.modifiedAddressData.type = this.selectType
            console.log('地址類型', this.selectType)
        }
    },
    methods: {
        close() {
            event.preventDefault()
            this.$emit('close')
        },
        confirm() {
            event.preventDefault()
            let addressData;
            if (this.isEdit) {
                addressData = this.getSelectedAddressData
                addressData.data = this.modifiedAddressData
            } else {
                addressData = {
                    data: this.modifiedAddressData,
                    index: null
                }
            }

            console.log('將送出的地址資訊', addressData)
            // 檢查地址類型
            // if (!addressData.data.type) {
            //     commonUtilities.createToast("error", "請選擇地址類型");
            //     return;
            // }
            // 檢查縣市
            if (!addressData.data.city_id) {
                commonUtilities.createToast("error", "請選擇縣市");
                return;
            }
            // 檢查行政區
            if (!addressData.data.cityarea_id) {
                commonUtilities.createToast("error", "請選擇行政區");
                return;
            }
            // 檢查地址
            if (!addressData.data.address) {
                commonUtilities.createToast("error", "請填寫地址");
                return;
            }
            // 檢查姓名
            if (!addressData.data.name) {
                commonUtilities.createToast("error", "請填寫姓名");
                return;
            }

            if (!addressData.data.phone) {
                commonUtilities.createToast("error", "請填寫手機門號");
                return;
            }

            // 檢查手機號碼格式
            if (!this.$validator.isValidPhoneNumber(addressData.data.phone)) {
                commonUtilities.createToast("error", "手機號碼格式錯誤");
                return;
            }
            this.$store.commit("basic/setSelectedAddressData", addressData)
            this.$emit('confirm')
        }
    },
}
</script>
<style lang="scss">
.address_input_container {
    width: 94vw;
    padding: 30px 0 0;
    background-color: #fff;
    border-radius: 8px;

    textarea,
    input {
        width: 86%;
        height: 100px;
        border: none;
        background-color: #fff;
        font-size: 18px;
        font-family: PingFang SC;
        color: #000;
        border-radius: 6px;
        padding: 10px;
        margin-top: 10px;
        border: 1px solid #AAAAAA;
    }

    input {
        height: 44px;
        padding: 0 10px;
        margin-top: 10px;
    }

    ::placeholder {
        color: rgba($color: #000000, $alpha: 0.3);
    }

    select {
        width: 86%;
        height: 44px;
        border: none;
        background-color: #fff;
        font-size: 18px;
        font-family: PingFang SC;
        color: #000;
        border-radius: 6px;
        border: 1px solid #AAAAAA;

        /* 隐藏默认的下拉箭头 */
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        // /* 添加自定义下拉箭头样式 */
        background-image: url("@/assets/custom-arrow.png");
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 28px 28px;
        /* 根据需要调整箭头图像的尺寸和位置 */
        padding: 10px;
    }

    button {
        width: 49.6%;
        height: 56px;
        border: none;
        font-size: 20px;
        font-weight: 500;
        font-family: PingFang SC;
        color: #000;
    }

    .cancel_button {
        border-radius: 0 0 0 8px;
        background-color: #EEEEEE;
    }

    .confirm_button {
        border-radius: 0 0 8px 0;
        background-color: #FBCB02;
    }
}
</style>